module.exports = __webpack_public_path__ + "lock-2ff7ec8942a185506892.png";